import { Injectable } from '@angular/core';
import { Mechanism } from '../models/mechanism';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MechanismService {

  constructor() { }

    getMechanisms(): Observable<Mechanism[]> {
      const mechanismList: Mechanism[] = [
        {
          id: 1,
          title: 'IS01 Sulfidation',
          code: 'IS01',
          nameEN: 'Sulfidation',
          nameRU: 'Сульфидирование',
          type: null
        },
        {
          id: 3,
          title: 'IS03 Creep and Stress Rupture',
          code: 'IS03',
          nameEN: 'Creep and Stress Rupture',
          nameRU: 'Ползучесть и механическое разрушение',
          type: null
        }
      ];
      // TODO: replace with real http call
      return of(mechanismList);
    }
}
